import {
  FETCH_PLACES_DATA,
  FETCH_PLACES_SUCCESS,
  FETCH_PLACES_FAILURE,
  FETCH_PLACES_EDIT_DATA,
  FETCH_PLACES_EDIT_SUCCESS,
  FETCH_PLACES_EDIT_FAILURE,
} from "./actionTypes"

const initialState = {
  loading: false,
  data: null,
  error: null,
  edit: {
    loading: false,
    data: null,
    error: null,
  },
}

const Places = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PLACES_DATA:
      return { ...state, loading: true, error: null }
    case FETCH_PLACES_SUCCESS:
      return { ...state, loading: false, data: action.payload }
    case FETCH_PLACES_FAILURE:
      return { ...state, loading: false, error: action.payload }

    case FETCH_PLACES_EDIT_DATA:
      return { ...state, edit: { loading: true, data: null, error: null } }
    case FETCH_PLACES_EDIT_SUCCESS:
      return {
        ...state,
        edit: { loading: false, data: action.payload, error: null },
      }
    case FETCH_PLACES_EDIT_FAILURE:
      return {
        ...state,
        edit: { loading: false, data: null, error: action.payload },
      }

    default:
      return state
  }
}

export default Places
